import React from 'react'
import {
  Link,
  Container,
  Icon64,
  TextBody,
  TextCaption
} from '@pmi/pmi-iqos-ds-react'
import {
  renderFormattedDate,
  htmlTranslation
} from '@pmi/pmi-iqos-shared-react'

const EligibleCoupon = ({ coupon, translations, handleApplyCoupon }) => {
  const couponExpirationText = htmlTranslation(
    translations,
    'tk_eligibleCouponValidUntil'
  )
  if (coupon.expiration) {
    couponExpirationText.value += ` ${renderFormattedDate(coupon.expiration)}`
  }
  return (
    <Container pt="4" fullWidth>
      <Container
        display={Container.displays.flex}
        bg={Container.backgrounds.white}>
        <Container px="4" py="3" fullWidth>
          <TextCaption size={TextCaption.sizes.s}>{coupon.name}</TextCaption>
          <TextBody
            style={TextBody.styles.success}
            size={TextBody.sizes.s}
            data-testing="Cart_TextBody_CouponDescription">
            {coupon.description}
          </TextBody>
          {coupon.expiration && (
            <TextBody
              style={TextBody.styles.grayedout}
              size={TextBody.sizes.s}
              data-testing="Cart_TextBody_CouponExpiration"
              {...couponExpirationText}
            />
          )}
        </Container>
        <Container
          px="5"
          py="3"
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}
          justifyContent={Container.justifyContentValues.center}
          alignItems={Container.alignItemsValues.center}
          divider={Container.dividers.left}
          dividerStyle={Container.dividerStyles.dashed}>
          <Container pb="2">
            <Icon64 size={Icon64.sizes.m} image={Icon64.images.vouchers} />
          </Container>
          <TextBody size={TextBody.sizes.s}>
            <Link
              newTab={false}
              onClickHandler={() => handleApplyCoupon(coupon)}
              data-testing="Cart_Link_ApplyCoupon">
              {translations.tk_eligibleCouponApply}
            </Link>
          </TextBody>
        </Container>
      </Container>
    </Container>
  )
}

export default EligibleCoupon
